import React from "react";
import { connect } from "react-redux";
import { Modal, Icon, Button } from "semantic-ui-react";
import PropTypes from "prop-types";

function TestoVendita({ datiScuola, t, isOpen, onClose }) {
  if (!datiScuola || Object.keys(datiScuola).length === 0) return null;

  const translate = (key, defaultVal) => {
    if (typeof t === "function") {
      const res = t(key);
      if (res && res !== key) return res;
    }
    return defaultVal;
  };

  const getHtmlContent = () => {
    const text = datiScuola.testoVendita || "";
    return text.replace(/\n/g, "<br>");
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="large"
      closeIcon
    >
      <Modal.Header>
        <Icon name="file alternate outline" />
        {translate("condizioni_vendita", "Condizioni di vendita")}
      </Modal.Header>
      <Modal.Content scrolling>
        <p
          style={{ textAlign: "justify", lineHeight: "1.6" }}
          dangerouslySetInnerHTML={{
            __html: getHtmlContent(),
          }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          icon="cancel"
          content={translate("chiudi", translate("annulla", "Chiudi"))}
        />
      </Modal.Actions>
    </Modal>
  );
}

TestoVendita.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    datiScuola: state.scuolaReducer,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TestoVendita);

